import React, { ReactElement } from "react";
import dynamic from "next/dynamic";
import { LoadingSkeleton } from "@kunduz/ui";
import { IContent } from "@kunduz/data-access-cms-api";
import styles from "./desktopRightLoader.module.scss";

const MobileLazyLoadedBottom = dynamic<any>(
  () => {
    return import("./mobileBottom").then((module) => module.MobileBottom);
  },
  {
    ssr: false,
    loading: () => (
      <div style={{ display: "flex", gap: 12 }}>
        <LoadingSkeleton className={styles.loader} />
        <LoadingSkeleton style={{ width: 150, height: 44 }} />
      </div>
    ),
  },
);

export const MobileBottomLoader = (props: {
  headerType: "student" | "teacher" | "school";
  mobileBottomCmsData?: IContent.HeaderItemsResponse["components"];
  lang: "tr" | "en";
}): ReactElement => {
  return <MobileLazyLoadedBottom {...props} />;
};
